export const wrapper = `flex flex-col gap-4 w-full lg:flex-row`;
